<div *ngIf="docItems else docitemloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

  <p-table #docItemTable [value]="docItems"
           dataKey="DOCITEMID"
           [loading]="loading"
           selectionMode="multiple"
           [(selection)]="sDI"
           (onRowSelect)="onRowSelect($event)"
           [rowHover]="true"
           [resizableColumns]="true"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           editMode="row"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

    <ng-template pTemplate="caption" *ngIf="showHeader">
      <div class="grid vertical-container">
        <div class="col align-self-start mb-2">
          <p-selectButton [options]="showDocRowsOptions" [(ngModel)]="showRowOptions"
                          multiple="multiple" optionLabel="name" optionValue="value" optionDisabled="disabled"
                          (onChange)="onRowsOptionChange($event)" styleClass="mr-2 mt-2"
                          pTooltip="Показывать дополнительные поля документа" tooltipPosition="top">
          </p-selectButton>
        </div>
        <div class="col align-self-end mb-2">
          <div class="grid justify-content-end">
            <p-button icon="pi pi-euro" styleClass="p-button-success mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="updMainPrice($event)"
                      pTooltip="Обновить цену в гривне (основной валюте)" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-dollar" styleClass="p-button-success mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="updCurrPrice($event)"
                      pTooltip="Обновить валютную цену" tooltipPosition="top"></p-button>
            <p-button label="Сохранить" icon="pi pi-save" styleClass="p-button-success mr-2 hide-label" (onClick)="onSaveRows($event)" [disabled]="!changes || editMode"
                      pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>
            <p-button label="Отменить" icon="pi pi-undo" styleClass="p-button-warning mr-2 hide-label" (onClick)="onUndoRows($event)" [disabled]="!changes || editMode"
                      pTooltip="Отменить изменения в цене" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-sort" styleClass="p-button-success mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="cleanSortMode($event)"
                      pTooltip="Убрать сортировку" tooltipPosition="top"></p-button>

            <p-button label="Нумеровать" icon="pi pi-sort-numeric-down" styleClass="p-button-success mr-4 hide-label" [disabled]="noItems || editMode" (onClick)="updateRowIndexes($event)"
                      pTooltip="Обновить индексы строк в документе" tooltipPosition="top"></p-button>

            <p-button label="Обновить" icon="pi pi-refresh" styleClass="p-button-success ml-2 mr-2 hide-label" (onClick)="reloadDocContent($event)" [disabled]="editMode"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>

            <p-splitButton label="XLSX" icon="pi pi-file-excel" [model]="excelExportItems" styleClass="p-button-info hide-label mr-2"
                           [disabled]="disableExportButton" (onDropdownClick)="checkCommand($event)" (onClick)="onExportData()"
                           pTooltip="Экспортировать содержимое документа" tooltipPosition="top"></p-splitButton>

          </div>
        </div>
      </div>

      <div class="grid" *ngIf="allowTopButtons && allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2 hide-label" [disabled]="editMode || noItems"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2 hide-label" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem" *ngIf="allowEditControls">
          <div class="col align-self-start">
            <p-selectButton [options]="showFilterOptions" [(ngModel)]="showFilterValue" multiple="multiple" optionValue="value" optionDisabled="disabled" optionLabel="icon"
                            pTooltip="Показывать фильтр по полям таблицы" tooltipPosition="top">
              <ng-template let-item pTemplate>
                <i [class]="item.icon"></i>
              </ng-template>
            </p-selectButton>
          </div>
        </th>
        <th pSortableColumn="PRODCODE" style="width:25%" pResizableColumn>Код товара <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pSortableColumn="PRODCUSTCODE" style="width:8rem" pResizableColumn *ngIf="seeTariffCode">Код УКТЗЕД <p-sortIcon field="PRODCUSTCODE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMPRODNAME" style="width:35%" pResizableColumn>Название товара <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMQTY" style="width:7rem" pResizableColumn>Количество <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>

        <th pSortableColumn="U4ETKA" style="width:8rem" pResizableColumn *ngIf="canSeeInvoice">Инвойс <p-sortIcon field="U4ETKA"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMSUMU4" style="width:8rem" pResizableColumn *ngIf="canSeeInvoice">Сумма инвойса <p-sortIcon field="DOCITEMSUMU4"></p-sortIcon></th>

        <th pSortableColumn="DOCITEMSHIPPED" style="width:7rem" pResizableColumn>Получено <p-sortIcon field="DOCITEMSHIPPED"></p-sortIcon></th>
        <th pSortableColumn="prodInfo.PRODSTOCK" style="width:6rem" pResizableColumn *ngIf="!editMode && seeReservation">Склад <p-sortIcon field="prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th pSortableColumn="prodInfo.PRODRESERVE" style="width:6rem" pResizableColumn *ngIf="!editMode && seeReservation">Резерв <p-sortIcon field="prodInfo.PRODRESERVE"></p-sortIcon></th>
        <th pSortableColumn="prodInfo.PRODSOLD" style="width:6rem" pResizableColumn *ngIf="!editMode && seeReservation">Продано <p-sortIcon field="prodInfo.PRODSOLD"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMVPRICE" style="width:8rem" pResizableColumn>Цена $ <p-sortIcon field="DOCITEMVPRICE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMPRICE" style="width:8rem" pResizableColumn>Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMVSUM" style="width:8rem" pResizableColumn>Сумма $ <p-sortIcon field="DOCITEMVSUM"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMSUM" style="width:8rem" pResizableColumn>Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th pSortableColumn="prodInfo.PRODWEIGHT" style="width:6rem" pResizableColumn *ngIf="!editMode && canSeeInvoice">Вес <p-sortIcon field="prodInfo.PRODWEIGHT"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMSUMWEIGHT" style="width:6rem" pResizableColumn *ngIf="canSeeInvoice">Общий вес <p-sortIcon field="DOCITEMSUMWEIGHT"></p-sortIcon></th>
        <th pSortableColumn="prodInfo.VENDORPRICE" style="width:8rem" pResizableColumn *ngIf="!editMode && canSeeInvoice">Цена в базе <p-sortIcon field="prodInfo.VENDORPRICE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMPOSHIPPINGDATE" style="width:10rem" pResizableColumn *ngIf="canSeeInvoice">Дата отгрузки <p-sortIcon field="DOCITEMPOSHIPPINGDATE"></p-sortIcon></th>
        <th pSortableColumn="PAYITEMCLIID" style="width:5rem" pResizableColumn># <p-sortIcon field="PAYITEMCLIID"></p-sortIcon></th>
        <th style="width: 3rem"></th>
      </tr>

      <tr *ngIf="showFilter">
        <th style="width: 7rem" *ngIf="allowEditControls">Фильтр =></th>

        <th><input pInputText type="text" [(ngModel)]="cf3['PRODCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="seeTariffCode"><input pInputText type="text" [(ngModel)]="cf3['PRODCUSTCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCUSTCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRODNAME']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRODNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMQTY']" (input)="docItemTable.filter($event.target.value, 'DOCITEMQTY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th *ngIf="canSeeInvoice"><input pInputText type="text" [(ngModel)]="cf3['U4ETKA']" (input)="docItemTable.filter($event.target.value, 'U4ETKA', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="canSeeInvoice"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUMU4']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUMU4', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSHIPPED']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSHIPPED', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODSTOCK']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODSTOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODRESERVE']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODRESERVE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODSOLD']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODSOLD', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMVPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMVPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMVSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMVSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th *ngIf="!editMode && canSeeInvoice"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODWEIGHT']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODWEIGHT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="canSeeInvoice"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUMWEIGHT']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUMWEIGHT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode && canSeeInvoice"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.VENDORPRICE']" (input)="docItemTable.filter($event.target.value, 'prodInfo.VENDORPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="canSeeInvoice"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPOSHIPPINGDATE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPOSHIPPINGDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>

        <th><input pInputText type="text" [(ngModel)]="cf3['PAYITEMCLIID']" (input)="docItemTable.filter($event.target.value, 'PAYITEMCLIID', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th style="width: 3rem">...</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-docItem let-editing="editing" let-ri="rowIndex">
      <tr [pSelectableRow]="docItem" [pEditableRow]="docItem">

        <td *ngIf="allowEditControls">
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(docItem)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" [disabled]="!allowSave(docItem)" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(docItem)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(docItem, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-productselector [showLabel]="false" [searchText]="docItem.PRODCODE" [allowOld]="allowOld" (selectedProduct)="onProductSelection($event, docItem)" [style]="{'width':'60%'}"></app-productselector>
            </ng-template>
            <ng-template pTemplate="output">
              <a [routerLink]="['/edit-product', docItem.PRODID]">{{docItem.PRODCODE}}</a>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="background-color:ghostwhite" *ngIf="seeTariffCode"><span [class.redvalue]="docItem.nta" [class.greencolour]="!docItem.nta">{{docItem.PRODCUSTCODE}}</span></td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()" />
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" readonly alt="{{docItem.DOCITEMPRODNAME}}" />
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMQTY" [style]="{'width':'100%'}" step="1" style="text-align: right"
                     (change)="onDOCITEMQTYChange($event, docItem)" (keydown)="$event.stopPropagation()" />
            </ng-template>
            <ng-template pTemplate="output">
              <span [class.shipped]="docItem.sha" [class.missed]="docItem.mst">{{docItem.DOCITEMQTY | number:'1.0-2'}}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" class="invoice-field" [class.red-cell]="docItem.pdm" *ngIf="canSeeInvoice">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.U4ETKA" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMU4ETKAChange($event, docItem)" (keydown)="$event.stopPropagation()" />
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.U4ETKA | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right; " class="invoice-field" *ngIf="canSeeInvoice">{{docItem.DOCITEMSUMU4 | number:'1.2-2' }}</td>

        <td style="text-align: right; background-color:ghostwhite">
          {{docItem.DOCITEMSHIPPED | number:'1.0-2' }}
        </td>

        <td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODRESERVE | number:'1.0-2' }}
          </span>
        </td>
        <td style="text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODSOLD | number:'1.0-2' }}
          </span>
        </td>

        <td style="text-align: right" [class.missed]="docItem.cpn">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMVPRICE" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMVPRICEChange($event, docItem)" (keydown)="$event.stopPropagation()" />
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMVPRICE | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" [class.missed]="docItem.cpn">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMPRICE" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMPRICEChange($event, docItem)" (keydown)="$event.stopPropagation()" />
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMPRICE | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right; background-color:ghostwhite">{{docItem.DOCITEMVSUM | number:'1.2-2' }}</td>
        <td style="text-align: right; background-color:ghostwhite">{{docItem.DOCITEMSUM | number:'1.2-2' }}</td>

        <td style="text-align: right;" class="invoice-field" *ngIf="!editMode && canSeeInvoice">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODWEIGHT | number:'1.2-2' }}
          </span>
        </td>

        <td style="text-align: right; " class="invoice-field" *ngIf="canSeeInvoice">{{docItem.DOCITEMSUMWEIGHT | number:'1.2-2' }}</td>

        <td style="text-align: right; background-color: ghostwhite" [class.red-cell]="docItem.pdm" *ngIf="!editMode && canSeeInvoice">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.VENDORPRICE | number:'1.2-2' }}
          </span>
        </td>

        <td style="overflow: visible !important; " class="invoice-field" *ngIf="canSeeInvoice">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar dateFormat="dd.mm.yy" [(ngModel)]="docItem.DOCITEMPOSHIPPINGDATE" (onSelect)="onDateSelect($event, docItem)" showButtonBar="true" firstDayOfWeek="1" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              <!--              <span *ngIf="docItem.DOCITEMPOSHIPPINGDATE">{{docItem.DOCITEMPOSHIPPINGDATE | date: 'dd.MM.yyyy'}}</span>-->
              {{docItem.DOCITEMPOSHIPPINGDATE | date: 'dd.MM.yyyy'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.PAYITEMCLIID" [style]="{'width':'100%'}" min="0" step="10" style="text-align: right" (change)="onPAYITEMCLIIDChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">{{docItem.PAYITEMCLIID | number:'1.0-0'}}</ng-template>
          </p-cellEditor>
        </td>

        <td>
          <button *ngIf="!docItem.hlt" pButton pRipple type="button" icon="pi pi-check" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-success p-button-text"></button>
          <button *ngIf="docItem.hlt" pButton pRipple type="button" icon="pi pi-exclamation-triangle" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-danger p-button-text"></button>
        </td>

        <ng-template #waiting>
          <span>---</span>
        </ng-template>

      </tr>
    </ng-template>

    <ng-template pTemplate="footer" *ngIf="inputDocument as doc">
      <tr>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" *ngIf="allowEditControls">{{doc.DOCITEMS | number:'1.0-2'}}</td>
        <td>&nbsp;</td>
        <td *ngIf="seeTariffCode">&nbsp;</td>
        <td>&nbsp;</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCTOTALITEMS | number:'1.0-2'}}</td>

        <td *ngIf="canSeeInvoice">&nbsp;</td>
        <td *ngIf="canSeeInvoice" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCSUMU4ETKA | number:'1.2-2'}}</td>

        <td>&nbsp;</td>
        <td *ngIf="!editMode && seeReservation">&nbsp;</td>
        <td *ngIf="!editMode && seeReservation">&nbsp;</td>
        <td *ngIf="!editMode && seeReservation">&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCVSUM | number:'1.2-2'}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCSUM | number:'1.2-2'}}</td>

        <td *ngIf="!editMode && canSeeInvoice">&nbsp;</td>
        <td *ngIf="canSeeInvoice" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCSUMWEIGHT | number:'1.0-2'}}</td>
        <td *ngIf="!editMode && canSeeInvoice">&nbsp;</td>
        <td *ngIf="canSeeInvoice">&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid mt-2" *ngIf="allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" styleClass="p-button-success ml-2" (onClick)="onAddRow($event)" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Отменить выбор" icon="pi pi-minus" (onClick)="onRemoveSelection($event)" styleClass="p-button-info mr-2" [disabled]="editMode || !selection"
                      pTooltip="Отменить выбор всех строк" tooltipPosition="top"></p-button>
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2" [disabled]="editMode || noItems"
                      pTooltip="Убрать все строки" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку ({{sDI.length}})" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранные строки ({{sDI.length}})" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>

      <div class="fluid formgrid grid" *ngIf="inputDocument as doc">
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS1" class="do-not-wrap-text">Количество позиций</label>
          <p-inputNumber id="DS1" [(ngModel)]="doc.DOCITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS2" class="do-not-wrap-text">Общее количество</label>
          <p-inputNumber id="DS2" [(ngModel)]="doc.DOCTOTALITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS4" class="do-not-wrap-text">Сумма в валюте</label>
          <p-inputNumber id="DS4" [(ngModel)]="doc.DOCVSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS7" class="do-not-wrap-text">Сумма с НДС</label>
          <p-inputNumber id="DS7" [(ngModel)]="doc.DOCSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4" *ngIf="canSeeInvoice">
          <label for="DS5" class="do-not-wrap-text">Общий вес</label>
          <p-inputNumber id="DS5" [(ngModel)]="doc.DOCSUMWEIGHT" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4" *ngIf="canSeeInvoice">
          <label for="DS3" class="do-not-wrap-text">Сумма инвойса</label>
          <p-inputNumber id="DS3" [(ngModel)]="doc.DOCSUMU4ETKA" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">Пустой документ</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #docitemloading>
  <p>Содержимое документа загружается...</p>
</ng-template>
